Prism.languages.ini={comment:/^[ \t]*;.*$/m,selector:/^[ \t]*\[.*?\]/m,constant:/^[ \t]*[^\s=]+?(?=[ \t]*=)/m,"attr-value":{pattern:/=.*/,inside:{punctuation:/^[=]/}}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/prismjs/components/prism-ini.min.js
// module id = 1077
// module chunks = 0